import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { EventsService } from 'angular4-events';
import { DataService } from '../data.service';

declare var $:any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})

export class SidebarComponent implements OnInit {
  pending: any;
  pendingCount: any;
  rating:any;
  assignedRole:any[] = [];
  getdata :any;
  get getPengingRequest(): any {
    return localStorage.getItem('pendingRequests');
  }
  get pendingvalue():any
  {
    return localStorage.getItem('force_dropoff_pending_count');
  }
  constructor(
    private pubsub: EventsService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
    ) {
    this.pending = this.pubsub.subscribe('BusinessPending').subscribe((data) => {
      this.assignedRoles();
      this.pendingCount = window.localStorage.getItem('BusinessPendingCount');
      console.log('pendingCountpendingCountpendingCount', this.pendingCount);
    });
  }

  menueToggle(id) {
    setTimeout(() => {
    console.log('in toggle chk', id);
    $(id).css('display', 'block');
    }, 500);
  }
  ngOnInit() {
    $('#sidebar').css('display', 'block');
    if(window.localStorage.getItem('isauthenticated') == 'true') {
      this.assignedRoles();
    }
      this.pendingCount = window.localStorage.getItem('BusinessPendingCount');
      $(document).ready(function () {

        // $(document).on('click', function (e) {
        //   if ($(event.target).is("#menu-trigger, #menu-trigger *, #sidebar, #sidebar *")) return;
        //   $('#menu-trigger').removeClass('open');
        //
        //   if ($('#menu-trigger').hasClass('open')) {
        //     $('#menu-trigger').find('i').removeClass('fa-bars').addClass('fa-close');
        //   } else {
        //     $('#menu-trigger').find('i').removeClass('fa-close').addClass('fa-bars');
        //   }
        //
        //   $('#sidebar').removeClass('toggled');
        // });

        $('body').on('click', '#menu-trigger', function (e) {
          e.preventDefault();

          $('#sidebar').toggleClass('toggled');
          $(this).toggleClass('open');

          if ($(this).hasClass('open')) {
            $(this).find('i').removeClass('fa-bars').addClass('fa-close');
          } else {
            $(this).find('i').removeClass('fa-close').addClass('fa-bars');
          }

          $('.sub-menu.toggled').not('.active').each(function () {
            $(this).removeClass('toggled');
            $(this).find('ul').hide();
          });

        });
      });

  }
  assignedRoles() {
    this.dataService.getAssignedRoles(window.localStorage.getItem('token')).subscribe(
     (data:any) => {
        let roleId = new Array;
        this.assignedRole = data.data;
        this.cdr.detectChanges();
        for(let i = 0; i < this.assignedRole.length; i++) {
          roleId.push(this.assignedRole[i].id);
        }
        localStorage.setItem('userRoles', JSON.stringify(roleId));
      },
      err => console.log(err)
    );
  }

  sidebarRoleCheck(role) {
    let id = this.assignedRole.map(e => e.id).indexOf(role);
    // console.log(id,"check id")
    return id != -1;
  }

}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts